import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
   name: 'appStatutesIcons',
   standalone: true
})
export class AppStatutesIconsPipe implements PipeTransform {
   transform(value?: number | null): string {
      if (!value) return ''
      return this._iconsMap?.get(value) ?? ''
   }

   private _iconsMap?: Map<number, string>

   constructor() {
      this._iconsMap = new Map<number, string>()
         .set(1, 'assets/icons/app-status-1-icon.svg')
         .set(2, 'assets/icons/app-status-2-icon.svg')
         .set(3, 'assets/icons/app-status-3-icon.svg')
         .set(4, 'assets/icons/app-status-4-icon.svg')
         .set(5, 'assets/icons/app-status-5-icon.svg')
         .set(6, 'assets/icons/app-status-6-icon.svg')
         .set(7, 'assets/icons/app-status-7-icon.svg')
         .set(8, 'assets/icons/app-status-8-icon.svg')
         .set(9, 'assets/icons/app-status-9-icon.svg')
         .set(10, 'assets/icons/app-status-7-icon.svg')
         .set(11, 'assets/icons/app-status-6-icon.svg')
   }
}
